<!-- Button -->
<button
  mat-icon-button
  type="button"
  *ngIf="user"
  (click)="userActionsPanel.toggle($event)"
>
  <span class="relative">
    <img
      class="w-7 h-7 rounded-full"
      *ngIf="showAvatar && user.avatar"
      [src]="user.avatar"
    />
    <mat-icon
      *ngIf="!showAvatar || !user.avatar"
      [svgIcon]="'heroicons_outline:user-circle'"
    ></mat-icon>
    <span
      class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
      [ngClass]="{
        'mr-px mb-px': !showAvatar || !user.avatar,
        'bg-green-500': user.status === 'online',
        'bg-amber-500': user.status === 'away',
        'bg-red-500': user.status === 'busy',
        'bg-gray-400': user.status === 'not-visible'
      }"
    ></span>
  </span>
</button>

<p-overlayPanel
  #userActionsPanel
  [showCloseIcon]="false"
  (onHide)="showRoleSelection = false"
  appendTo="body"
>
  <div class="flex flex-col min-w-56">
    <ng-container *ngIf="user">
      <div class="px-4 py-2">
        <div class="flex flex-col leading-none text-sm">
          <span class="text-xs text-gray-500">Профиль</span>
          <span class="mt-1.5 text-md font-medium">{{ user.fio }}</span>
        </div>
      </div>
      <hr class="my-2 border-gray-200" />
    </ng-container>

    <button
      type="button"
      class="flex items-center gap-3 px-4 py-2 text-left text-sm transition-colors hover:bg-gray-100"
      (click)="navigateToProfilePage(); userActionsPanel.hide()"
    >
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      <span>Профиль</span>
    </button>

    <button
      type="button"
      class="flex items-center justify-between gap-3 px-4 py-2 text-left text-sm transition-colors hover:bg-gray-100"
      *ngIf="user"
      (click)="toggleRoleSelection()"
    >
      <span class="flex items-center gap-3">
        <mat-icon [svgIcon]="'heroicons_outline:adjustments'"></mat-icon>
        <span class="mat-caption">{{ user.mainRole }}</span>
      </span>
      <mat-icon
        [svgIcon]="
          showRoleSelection
            ? 'heroicons_outline:chevron-up'
            : 'heroicons_outline:chevron-down'
        "
      ></mat-icon>
    </button>

    <div
      *ngIf="showRoleSelection && user"
      class="flex flex-col border-t border-gray-100"
    >
      <button
        type="button"
        class="flex items-center gap-3 px-4 py-2 text-left text-sm transition-colors hover:bg-gray-100"
        *ngFor="let role of user.roles"
        (click)="changeMainRole($any(role)); userActionsPanel.hide()"
      >
        <mat-icon class="s-20" *ngIf="role === user.mainRole">check</mat-icon>
        <mat-icon class="s-20" *ngIf="role !== user.mainRole"
          >account_circle</mat-icon
        >
        <span>{{ role }}</span>
      </button>
    </div>

    <hr class="my-2 border-gray-200" />

    <button
      type="button"
      class="flex items-center gap-3 px-4 py-2 text-left text-sm text-red-600 transition-colors hover:bg-red-50"
      (click)="signOut(); userActionsPanel.hide()"
    >
      <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
      <span>Выход</span>
    </button>
  </div>
</p-overlayPanel>
